<template>
  <div class="mainContainer">
    <div class="nav">
      <div class="navContainer" style="width: 230px">
        <p>仓库名称：</p>
        <el-input v-model="entrustIpt" size="mini" style="width:150px" placeholder="请输入仓库名称"/>
      </div>
      <div class="navContainer" style="width: 230px">
        <p>费用类型：</p>
        <el-select v-model="typeIpt" filterable size="mini" style="width:150px" placeholder="请选择费用类型">
          <el-option v-for="item in typeOption" :key="item.label" :label="item.label" :value="item.value"/>
        </el-select>
      </div>
      <div class="navContainer">
        <p>状态：</p>
        <el-select v-model="stateIpt" filterable size="mini" style="width:150px" placeholder="请选择状态">
          <el-option v-for="item in stateOption" :key="item.label" :label="item.label" :value="item.value"/>
        </el-select>
      </div>
      <div class="navBtn">
        <el-button size="small" class="searchBtn" @click="searchBtn">查询</el-button>
        <el-button size="small" class="resetBtn" @click="resetBtn">重置</el-button>
        <el-button size="small" type="primary" @click="addBtn">新增</el-button>
      </div>
    </div>
    <div class="content">
      <div class="tableContainer">
        <el-table
          v-loading="tableLoad"
          :data="TableDatas"
          style="width: 100%"
          border
          stripe
          :header-cell-style="{color:'#3B3B3B','font-size':'13px','height':'48px',background:'#E8E8E8'}"
          :cell-style="{'color':'#7F7F7F','font-size':'13px','height':'52px',}"
        >
          <el-table-column label="序号" align="center" width="50px" type="index"/>
          <el-table-column prop="storehouseName" label="仓库名称" align="center"/>
          <el-table-column prop="expenseType" label="费用类型" align="center"/>
          <el-table-column prop="customerCarName" label="适配车型" align="center"/>
          <el-table-column prop="settlementType" label="结算类型" align="center">
            <div slot-scope="scope">{{getSettleType(scope.row.settlementType)}}</div>
          </el-table-column>
          <el-table-column prop="taxRate" label="税率" align="center"/>
          <el-table-column prop="price" label="单价" align="center"/>
          <el-table-column prop="startDate" label="有效起始" align="center">
            <div slot-scope="scope">{{getTime(scope.row.startDate)}}</div>
          </el-table-column>
          <el-table-column prop="endDate" label="结束时间" align="center">
            <div slot-scope="scope">{{getTime(scope.row.endDate)}}</div>
          </el-table-column>
          <el-table-column prop="status" label="状态" align="center">
            <div slot-scope="scope">{{getState(scope.row.status)}}</div>
          </el-table-column>
          <el-table-column label="操作" width="270" align="center">
            <template slot-scope="scope">
              <div style="display:flex;align-items:center;padding-left: 10px">
                <el-button size="mini" class="searchBtn" type="primary" @click="detailClick(scope.$index, scope.row)">详情</el-button>
                <el-button v-if="!scope.row.status" size="mini" class="yellow-bg" type="primary" @click="changeClick(scope.$index, scope.row)">修改</el-button>
                <el-button v-if="!scope.row.status" size="mini" type="primary" @click="enableClick(scope.$index, scope.row)">启用</el-button>
                <el-button v-if="scope.row.status===1" size="mini" type="danger" @click="disableClick(scope.$index, scope.row)">停用</el-button>
                <el-button v-if="scope.row.isDelete" size="mini" type="info" @click="deleteClick(scope.$index, scope.row)">删除</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paginationContainer">
        <span>共{{total}}条</span>
        <el-pagination
          background
          :page-sizes="[10, 20, 30, 40]"
          layout="sizes,prev, pager, next,jumper"
          :total="total"
          @size-change="contractSizeChange"
          @current-change="contractCurrentChange"
          @prev-click="contractCurrentChange"
          @next-click="contractCurrentChange"
        />
      </div>
    </div>
    <el-dialog title="详情" :visible.sync="detailDialogVisible" width='600px' center top="10vh">
      <div class="detail">
        <div class="baseInfo">
          <div class="baseInfoTitle">
            <div class="line"/>
            <span>基础信息</span>
          </div>
          <div class="baseInfoContent">
            <div class="baseInfoContentItem">
              <span class="span1">仓库名称：</span>
              <span>{{detailData.name}}</span>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">费用类型：</span>
              <span>{{detailData.name}}</span>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">适配车型：</span>
              <span>{{detailData.name}}</span>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">有效起始：</span>
              <span>{{detailData.time1}}</span>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">结算时间：</span>
              <span>{{detailData.time2}}</span>
            </div>
          </div>
        </div>
        <div class="baseInfo">
          <div class="baseInfoTitle">
            <div class="line"/>
            <span>费用设置</span>
          </div>
          <div class="baseInfoContent">
            <div class="baseInfoContentItem">
              <span class="span1">结算类型：</span>
              <span>{{detailData.port}}</span>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">税率：</span>
              <span>{{detailData.price1}}</span>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">单价：</span>
              <span>{{detailData.price2}}</span>
            </div>
          </div>
        </div>
        <div class="operation">
          <div class="operationTitle">
            <div class="line"/>
            <span>操作信息</span>
          </div>
          <div class="operationTable">
            <el-table :data="operationData" border>
              <el-table-column label="操作时间" align="center" width="160px">
                <div slot-scope="scope">{{getTime(scope.row.createTime)}}</div>
              </el-table-column>
              <el-table-column prop="operateType" label="操作类型" align="center"/>
              <el-table-column prop="operationName" label="操作人" align="center"/>
              <el-table-column prop="remark" label="备注" align="center"/>
            </el-table>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width='650px' center @close="dialogClose" :close-on-click-modal="false">
      <div class="depart">
        <el-form :model="companyData" label-width="85px" :rules="rules" ref="ruleForm">
          <div-border label="基础信息" divStyle="margin-top: 10px">
            <el-row>
              <el-col>
                <el-form-item label="仓库名称：" style="margin-top: 10px;" prop="name">
                  <el-select v-model="companyData.name" filterable size="mini" style="width:100%" placeholder="请选择仓库" value-key="id" @change="nameChange">
                    <el-option v-for="item in nameOption" :key="item.id" :label="item.name" :value="item"/>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item label="费用类型：" prop="type">
                  <el-select v-model="companyData.type" filterable size="mini" style="width:100%" placeholder="请选择费用类型" value-key="id" @change="nameChange">
                    <el-option v-for="item in typeOption2" :key="item.id" :label="item.name" :value="item"/>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item label="适配车型：" style="margin-bottom: 0">
                  <span style="margin-right: 5px;" v-for="(item,index) in selectedCar">{{item.name}}<span v-if="index!==selectedCar.length-1">、</span></span>
                  <span style="color: rgba(51, 136, 255, 1);cursor: pointer;" @click="carClick">点击选择车辆</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="有效期始：" prop="start" style="margin-bottom: 20px">
                  <el-date-picker
                    v-model="companyData.start"
                    size="mini"
                    type="datetime"
                    style="width:100%"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    placeholder="请选择有效开始时间"/>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="结束日期：" prop="end">
                  <el-date-picker
                    v-model="companyData.end"
                    size="mini"
                    type="datetime"
                    style="width:100%"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    placeholder="请选择有效结束时间"/>
                </el-form-item>
              </el-col>
            </el-row>
          </div-border>
          <div-border label="费用设置" divStyle="margin-top: 10px">
            <el-row>
              <el-col>
                <el-form-item label="结算类型：" style="margin-top: 10px;" prop="settleType">
                  <el-radio-group size="mini" v-model="companyData.settleType">
                    <el-radio :label="1">辆</el-radio>
                    <el-radio :label="2">月</el-radio>
                    <el-radio :label="3">年</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item label="税率：" prop="rate">
                  <el-input
                    style="width:80%;"
                    v-model="companyData.rate"
                    placeholder="请输入税率"
                    autocomplete="off"
                    size="mini"
                  >
                    <span slot="suffix" style="color: #999">|  %</span>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item label="单价：" prop="price">
                  <el-input
                    style="width:80%;"
                    v-model="companyData.price"
                    placeholder="请输入单价"
                    autocomplete="off"
                    size="mini"
                  >
                    <span slot="suffix" style="color: #999;">|  元</span>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div-border>
          <div class="btnContainer">
            <el-button size="medium" class="searchBtn" :loading="addLoad" @click="addClick">确定</el-button>
            <el-button size="medium" class="resetBtn" @click="dialogClose">关闭</el-button>
          </div>
        </el-form>
      </div >
    </el-dialog>
    <el-dialog title="选择适配车型" :visible.sync="carVisible" width='600px' @close="carClose" center :close-on-click-modal="false" top="20vh">
      <div class="carContainer">
        <div class="carContainerTitle">
          <span>已选择车型：</span>
          <div class="carContainerTitleContent">
            <div class="carContainerTitleContentItem" v-for="item in selectCar" @click="selectRemove(item)">
              {{item.name}}<i class="el-icon-close"/>
            </div>
          </div>
        </div>
        <div class="carContainerTitle">
          <span>选择品牌：</span>
          <div class="carContainerTitleContent">
            <div class="carContainerTitleContentItem" v-for="item in selectBrand">
              <p @click="brandClick(item.id)">{{item.name}}&nbsp;</p><i class="el-icon-plus" @click="brandAdd(item)"/>
            </div>
          </div>
        </div>
        <div class="carContainerTitle">
          <span>选择型号：</span>
          <div class="carContainerTitleContent">
            <div class="carContainerTitleContentItem" v-for="item in selectModel" @click="modelAdd(item)">
              <p>{{item.name}}</p><i class="el-icon-plus"/>
            </div>
          </div>
        </div>
        <div class="btnContainer">
          <el-button class="searchBtn" size="mini" @click="carAddClick">确定</el-button>
          <el-button class="resetBtn" size="mini" @click="carClose">关闭</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import steps from "@/components/steps";
import {formatDateTime} from "@/config/mUtils";
import divBorder from "@/components/divBorder";
import {addStorehouseInfo, getCarSerieList, storehouseInfoList} from "@/service/financial";

export default {
  components: {
    steps,
    divBorder,
  },
  data() {
    return {
      entrustIpt:'',
      typeIpt:'',
      stateIpt:'',
      stateOption:[
        {value:'',label:'全部',},
        {value:0,label:'待生效'},
        {value:1,label:'生效中'},
        {value:2,label:'已失效'},
      ],
      typeOption:[
        {value:'',label:'全部',},
        {value:1,label:'待生效'},
        {value:2,label:'已失效'},
        {value:3,label:'生效中'},
      ],
      page:1,
      size:10,
      total:0,
      tableLoad:false,
      TableDatas:[
        {name:'委托商1',potr:'港口1',brand:'品牌1',model:'型号2',price1:'10',price2:'10',price3:'无',time1:'2021-11-3 16:37:19',time2:'2021-11-3 16:37:19',state:'待生效'},
        {name:'委托商1',potr:'港口1',brand:'品牌1',model:'型号2',price1:'10',price2:'10',price3:'无',time1:'2021-11-3 16:37:19',time2:'2021-11-3 16:37:19',state:'生效中'},
        {name:'委托商1',potr:'港口1',brand:'品牌1',model:'型号2',price1:'10',price2:'10',price3:'无',time1:'2021-11-3 16:37:19',time2:'2021-11-3 16:37:19',state:'已失效'},
      ],
      detailDialogVisible:false,
      detailData:{},
      operationData:[],
      dialogVisible:false,
      dialogTitle:'',
      addLoad:false,
      nameOption:[
        {id:1,name:1},
      ],
      typeOption2:[
        {id:1,name:1},
      ],
      companyData:{},
      rules:{
        name:[
          { required: true, message: '请选择委托商', trigger: 'change' },
        ],
        start:[
          { required: true, message: '请选择有效开始时间', trigger: 'change' },
        ],
        end:[
          { required: true, message: '请选择有效结束时间', trigger: 'change' },
        ],
        type:[
          { required: true, message: '请选择费用类型', trigger: 'change' },
        ],
        settleType:[
          { required: true, message: '请选择结算类型', trigger: 'change' },
        ],
        rate:[
          { required: true, message: '请输入税率', trigger: 'change' },
        ],
        price:[
          { required: true, message: '请输入单价', trigger: 'change' },
        ],
      },
      carVisible:false,
      selectedCar:[],
      selectCar:[],
      brands:[],
      models:[],
      brands2:[],
      models2:[],
      selectBrand:[],
      selectModel:[],
      allCar:[],
      allModel:[],
    };
  },
  computed:{
    getSettleType(){
      return function(state){
        switch(state) {
          case 1:
            return '辆'
          case 2:
            return '月'
          case 3:
            return '年'
        }
      };
    },
    getState(){
      return function(state){
        switch(state) {
          case 0:
            return '待生效'
          case 1:
            return '生效中'
          case 2:
            return '已生效'
        }
      };
    },
    getTime(){
      return function(time){
        return formatDateTime(time,'yyyy年mm月dd日 hh:ii:ss')
      };
    },
  },
  async mounted() {
    await this._storehouseInfoList();
    const res = await getCarSerieList();
    if(res.status !== 0) this.$message.error(res.message);
    else {
      this.allCar=res.data;
      this.selectBrand = res.data.map(item => {
        return {
          name: item.brand,
          id: item.id,
        }
      })
      res.data.forEach(item =>{
        if(item.carModel.length !== 0) this.allModel=[...this.allModel,...item.carModel]
      })
    }
  },
  methods: {
    async _storehouseInfoList(){
      this.tableLoad=true;
      const res = await storehouseInfoList(
        {
          status:this.stateIpt,
          expenseType:this.typeIpt,
          storehouseName:this.entrustIpt,
          rows:this.size,
          page:this.page,
        }
      );
      this.tableLoad=false;
      if(res.status !== 0) return this.$message.error(res.message);
      this.TableDatas=res.data.records;
      this.total=res.data.total
    },
    contractSizeChange(sizes){
      this.size=sizes;
      this._storehouseInfoList();
    },
    contractCurrentChange(page){
      this.page=page;
      this._storehouseInfoList();
    },
    dialogClose(){
      this.dialogVisible=false;
      this.$refs.ruleForm.resetFields();
    },
    addClick(){
      this.$refs.ruleForm.validate(async valid => {
        if (valid) {
          this.addLoad = true;
          const obj = {

          };
          const res = await addStorehouseInfo(obj);
          this.addLoad = false;
          if(res.status !== 0) return this.$message.error(res.message);
          this.$message.success(res.message);
          this.dialogVisible=false;
          await this._storehouseInfoList();
        } else return false;
      });
    },
    nameChange(){},
    deleteClick(){
      this.$confirm('确认删除当前仓库价格设置吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
      }).catch(() => {});
    },
    disableClick(){
      this.$confirm('确认停用当前仓库价格设置吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
      }).catch(() => {});
    },
    detailClick(){
      this.detailDialogVisible=true;
    },
    changeClick(){
      this.dialogVisible=true;
      this.dialogTitle='修改仓库价格'
    },
    searchBtn(){
      this.page = 1;
      this._storehouseInfoList();
    },
    addBtn(){
      this.dialogVisible=true;
      this.dialogTitle='添加仓库价格'
      this.companyData={
        transfer:1,
        mention:1,
        discharge:1,
      }
    },
    resetBtn(){
      this.entrustIpt='';
      this.typeIpt='';
      this.stateIpt='';
    },
    enableClick(){
      this.$confirm('确认启用当前仓库价格设置吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
      }).catch(() => {});
    },
    carClick(){
      this.carVisible=true;
      this.selectCar=[...this.selectedCar];
      this.brands=[...this.brands2];
      this.models=[...this.models2];
    },
    selectRemove(item){
      this.selectCar.splice(this.selectCar.indexOf(item),1)
      if(this.brands.indexOf(item)!==-1) this.brands.splice(this.brands.indexOf(item),1)
      else this.models.splice(this.models.indexOf(item),1)
    },
    brandAdd(item){
      if(this.selectCar.indexOf(item)!==-1) return this.$message.warning('已选择该品牌！');
      let arr = [];
      for(let i=0;i<this.allCar.length;i++){
        if(this.allCar[i].id===item.id){
          arr=this.allCar[i].carModel;
          break;
        }
      }
      for(let i=0;i<arr.length;i++){
        for(let j=0;j<this.selectCar.length;j++){
          if(arr[i].id===this.selectCar[j].id){
            this.selectCar.splice(j,1);
            j--;
          }
        }
      }
      this.selectCar.push(item)
      this.brands.push(item)
    },
    modelAdd(item){
      for(let i=0;i<this.selectCar.length;i++){
        if(this.selectCar[i].id===item.brandId) return this.$message.warning('上方已选择该品牌的全部车型！');
        else if(this.selectCar[i].id===item.id) return this.$message.warning('已选择该车型！');
      }
      this.selectCar.push(item)
      this.models.push(item)
    },
    carAddClick(){
      this.carVisible=false;
      this.selectedCar=[...this.selectCar];
      this.brands2=[...this.brands];
      this.models2=[...this.models];
    },
    carClose(){
      this.carVisible=false;
    },
    brandClick(id){
      for(let i=0;i<this.allCar.length;i++){
        if(this.allCar[i].id===id){
          this.selectModel=this.allCar[i].carModel.map(item=>{
            return{
              id:item.id,
              name:item.brand_name,
              brandId:item.brand_id,
            }
          });
          break;
        }
      }
    },
  },
};
</script>



<style lang="scss" scoped>
.mainContainer{
  width:100%;
  padding:20px 15px 0 25px;
  background-color: #fff;
  .line{
    width: 12px;
    height: 32px;
    background-color: rgba(51, 84, 131, 100);
    margin-right: 10px;
  }
  .line +span{
    font-size: 16px;
    color: rgba(51, 84, 131, 100);
    font-weight: 600;
  }
  .nav{
    width:100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    &Container{
      width:200px;
      display: flex;
      align-items: center;
      margin-right: 5px;
      margin-bottom: 5px;
      p{
        font-size: 14px;
        color: rgba(16, 16, 16, 100);
      }
    }
    &Btn{
      display: flex;
      align-items: center;
      margin-bottom: 5px;
    }
      ::v-deep {
        label.el-form-item__label {
          font-weight: 500;
          color: #101010;
        }
      }
  }
  .content{
    display: flex;
    flex-direction: column;
    align-items: center;
    .tableContainer{
      margin-top: 30px;
      margin-bottom: 25px;
      width: 100%;
      ::v-deep{
        .el-badge__content{
          top: 4px !important;
          right: 1px !important;
        }
        .el-badge__content{
          background-color: #F56C6C !important;
        }
        .el-table .cell {
          padding: 0;
        }
        .el-table th{
          padding: 0;
        }
        .el-table td{
          padding: 0;
        }
      }
    }
    .paginationContainer{
      margin-right: auto;
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      span{
        font-size: 13px;
      }
    }
  }
  .detail{
    width: 100%;
    padding: 10px 0 20px 20px;
    max-height:80vh;
    overflow: auto;
    .baseInfo{
      display: flex;
      flex-direction: column;
      &Title{
        display:flex;
        align-items:flex-end;
        p{
          font-weight: 700;
          font-size: 14px;
          color: rgba(51, 136, 255, 1);
          margin-left: 10px;
        }
      }
      &Content{
        display:flex;
        flex-direction: column;
        justify-content: space-between;
        padding:20px 23px 0 23px;
        .addressItem{
          font-size: 12px;
          color: rgba(153, 153, 153, 1);
          margin-bottom: 10px;
          margin-left: 70px;
        }
        &Item{
          margin-bottom: 20px;
          .imgContainer{
            display:flex;
            align-items: center;
          }
          .span1{
            font-weight: 700;
          }
          span{
            font-size: 14px;
          }
          .specialOne{
            width:50%;
          }
        }
        .specialItem{
          display:flex;
        }
      }
    }
    .operation{
      display: flex;
      flex-direction: column;
      ::v-deep{
        .el-table td, .el-table th{
          padding:0;
        }
        .cell{
          font-size: 10px;
          padding:0;
        }
      }
      &Title{
        display:flex;
        align-items:flex-end;
        p{
          font-weight: 700;
          font-size: 14px;
          color: rgba(51, 136, 255, 1);
          margin-left: 10px;
        }
      }
      &Table{
        width:100%;
        margin-top: 10px;
        padding: 0 20px;
      }
    }
  }
  .reasonContainer{
    width:100%;
    padding: 20px 30px;
    ::v-deep{
      .el-textarea__inner{
        min-height: 100px!important;
      }
    }
    .reasonBtn{
      width: 100%;
      display: flex;
      align-items: center;
      justify-content:flex-end;
    }
  }
  .carContainer{
    width:100%;
    padding: 15px 40px 10px 20px;
    max-height:75vh;
    overflow:auto;
    &Title{
      display: flex;
      flex-direction: column;
      span{
        color: #101010;
        font-weight: 700;
        margin-bottom: 5px;
      }
      &Content{
        width:100%;
        padding-left: 15px;
        display: flex;
        flex-wrap: wrap;
        align-items:center;
        margin-bottom: 10px;
        &Item{
          height:25px;
          padding:0 5px;
          background-color: #a4adb3;
          color:#fff;
          display: flex;
          align-items:center;
          justify-content:space-between;
          margin-right: 10px;
          margin-bottom: 5px;
          i{
            color:#000;
            font-size: 17px;
            cursor: pointer;
          }
          p{
            cursor: pointer;
          }
        }
      }
    }
    .btnContainer{
      width:100%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 30px 0 10px 0;
      button{
        margin: 0 15px;
      }
    }
  }
  .depart{
    width:100%;
    padding: 10px 40px 10px 10px;
    max-height:75vh;
    overflow:auto;
    .specialItem{
      ::v-deep {
        .el-form-item__content{
          margin-left: 0!important;
        }
      }
    }
    ::v-deep{
      .el-form-item__label{
        font-weight: 700;
      }
      .el-form-item{
        margin-bottom:13px;
      }
      .el-form-item__label{
        padding:0;
      }
      .el-form-item__content{
        position: relative;
      }
    }
    .btnContainer{
      width:100%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 30px 0 10px 0;
      button{
        margin: 0 15px;
      }
    }
  }

  ::v-deep{
    .el-table th>.cell{
      font-weight: 700!important;
    }
  }
}
::v-deep{
  .el-dialog__header {
    padding: 9px 20px 9px;
    background: #335483;
  }
  .el-dialog__title {
    line-height: 24px;
    font-size: 14px;
    color: #FFFFFF;
  }
  .el-dialog__headerbtn{
    top:9px;
  }
  .el-dialog__headerbtn .el-dialog__close {
    color: #fff;
    font-size: 25px;
  }
  .el-dialog__body {
    padding: 0;
  }
}
</style>
